import { validateFileSize, validateFileType, getFileAccept, fileToBase64, base64ToFileStream } from 'utils/file-uploader';
import { ValidateOptions } from './models'

class Service{
    async preparePdfFile(file: File) {
        await this.validatePdfFile(file, { size: 50 })

        const result = await this.prepareRequestpdfFile(file)

        return result

    }

    private async validatePdfFile (file: File, options: ValidateOptions) {
        const { size } = options;

        const { contentTypes } = getFileAccept('.pdf')

        await Promise.all([
            validateFileSize(file, size),
            validateFileType({ file, contentTypes, skipContentTypes: [] })
        ])
    }
    private async prepareRequestpdfFile (file: File) {
        const timtstamp = new Date().getTime();

        const fileName = `pdfs/${timtstamp}__${file.name}`;
        const base64 = await fileToBase64(file)

        const fileStreamString = base64ToFileStream(base64)

        return {
            fileName,
            fileStreamString,
        }
    }
}

export const ServiceMediaUploads = new Service() 